<template>
    <div>

        <div v-if="show">
            <div class="form-group">
                <label for="fullname">手机号</label>
                <input class="form-control" v-model="phone" placeholder="请输入手机号" required>
            </div>
            <label for="emailaddress">验证码</label>
            <div class="input-group" style="margin-bottom:10px">
                <input type="text" class="form-control" v-model="code" placeholder="请输入验证码">
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" @click="_getCode"
                        :disabled="disabled">{{codeBtn}}</button>
                </div>
            </div>
            <div class="form-group mb-0 text-center" style="margin-top:20px">
                <button class="btn btn-primary btn-block" @click="_getQuery">查询授权记录
                </button>
            </div>
        </div>

        <div v-else>
            <div>
                <Card class="list-goods-list-item" v-for="item in data" :key="item.id">
                    <div class="name">
                        {{item.url}} {{item.version}}
                        <Tag color="orange" style="float: right; font-weight: 100">
                            {{ item.project_name }}</Tag>
                    </div>
                    <div class="explain">授权到期时间：{{item.endtime}}</div>
                </Card>
            </div>
        </div>



    </div>
</template>
<script>
    import {
        getCode,
        getQuery
    } from "@/api/index"
    export default {
        data() {
            return {
                codeBtn: "获取验证码",
                countdown: 120,
                disabled: false,
                data: [],
                show: true,
                phone: "",
                code: "",
            }
        },
        created() {},
        methods: {

            //获取验证码
            _getCode() {
                var reg = /^1[3456789]\d{9}$/;
                var user = reg.test(this.phone);
                if (!user) {
                    return this.$Message.warning({
                        background: true,
                        content: "请填写正确的手机号",
                    });
                }
                this.$Message.loading({
                    content: "获取中...",
                    duration: 2,
                });
                getCode({
                    phone: this.phone
                }).then(res => {
                    if (res.code == 200) {
                        this.$Message.success({
                            background: true,
                            content: res.msg,
                        });
                        this.settime(120);
                    } else {
                        this.$Message.error({
                            background: true,
                            content: res.msg,
                        });
                    }
                })
            },

            //验证码
            settime(e) {
                //验证码动态
                if (this.countdown == 0) {
                    (this.codeBtn = "重新发送"),
                    (this.countdown = "120"),
                    (this.disabled = false);
                    return;
                } else {
                    (this.codeBtn = "重新发送(" + this.countdown + ")"),
                    (this.disabled = true);
                    this.countdown--;
                }
                setTimeout(() => {
                    this.settime(120);
                }, 1000);
            },

            // 查询授权
            _getQuery() {
                if (!this.phone) {
                    return this.$Message.warning({
                        background: true,
                        content: "请填写正确的手机号",
                    });
                }
                if (!this.code) {
                    return this.$Message.warning({
                        background: true,
                        content: "请填写验证码",
                    });
                }

                getQuery({
                    phone: this.phone,
                    code: this.code,
                }).then(res => {
                    if (res.code == 200) {
                        this.$Message.success({
                            background: true,
                            content: res.msg,
                        });
                        this.data = res.data
                        if (res.data.length == 0) {
                            this.$Message.error({
                                background: true,
                                content: '该手机号暂无授权记录',
                            });
                        } else {
                            this.show = false
                        }
                    } else {
                        this.$Message.error({
                            background: true,
                            content: res.msg,
                        });
                    }
                })
            },



        },
    }
</script>

<style lang="less" scoped>
    .list-goods-list-item {
        margin-bottom: 10px;

        .name {
            font-size: 16px;
            font-weight: 600;
            color: red;

            span {
                float: right;
                color: #000000;
            }
        }

        .price {
            font-size: 20px;
            color: red;

            .old {
                font-size: 16px;
                color: #ccc;
                text-decoration: line-through;
                margin-left: 10px;
            }
        }

        .explain {
            font-size: 14px;
            color: #000000;
            margin: 5px 0;
        }
    }
</style>